import assetPath from '/app/packages/startpage-logged-out/native-apps-section/src/assets/qrcode.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')